<template>
  <el-card shadow="hover" v-loading="loading">
    <div slot="header" class="header">
      <div class="title">
        <span>开门日志</span>
        <el-tag v-if="total > 0" size="mini" type="info" style="margin-left: 8px;">{{ total }} 条</el-tag>
      </div>
      <div class="filters">
        <el-select v-model="openType" size="small" style="width: 140px;" @change="onFilterChange">
          <el-option label="全部类型" value="all" />
          <el-option label="平台开门" value="platform" />
          <el-option label="小程序开门" value="mini_program" />
          <el-option label="设备上报开门" value="device" />
        </el-select>
        <el-input
          v-model.trim="keyword"
          size="small"
          clearable
          placeholder="搜索设备编号/设备名称/人员"
          style="width: 240px;"
          @keyup.enter.native="onFilterChange"
          @clear="onFilterChange"
        />
        <el-button size="small" icon="el-icon-search" @click="onFilterChange">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </div>
    </div>

    <el-table :data="list" border stripe highlight-current-row empty-text="暂无开门日志">
      <el-table-column prop="id" label="ID" width="88" />
      <el-table-column prop="openTypeLabel" label="开门类型" width="130">
        <template slot-scope="scope">
          <el-tag size="mini" :type="tagType(scope.row.openType)">{{ scope.row.openTypeLabel }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="deviceId" label="设备编号（柜编号）" width="160">
        <template slot-scope="scope">
          {{ scope.row.deviceId || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="deviceName" label="设备名称（柜名称）" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.deviceName || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="operatorName" label="开门人员" width="120">
        <template slot-scope="scope">
          {{ scope.row.operatorName || (scope.row.userId ? ("用户#" + scope.row.userId) : "-") }}
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="IP" width="140" />
      <el-table-column prop="createdAt" label="时间" width="170">
        <template slot-scope="scope">
          {{ formatTime(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="rawDetail" label="详情" min-width="260" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ formatOpenDetail(scope.row) }}
        </template>
      </el-table-column>
    </el-table>

    <div style="height: 12px;"></div>
    <el-pagination
      background
      layout="total, prev, pager, next"
      :current-page.sync="page"
      :page-size="pageSize"
      :total="total"
      @current-change="refresh"
    />
  </el-card>
</template>

<script>
import { getOpenLogs } from "@/api";

export default {
  name: "OpenLog",
  data() {
    return {
      list: [],
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      openType: "all",
      keyword: ""
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    tagType(type) {
      if (type === "platform") return "success";
      if (type === "mini_program") return "primary";
      if (type === "device") return "warning";
      return "info";
    },
    formatTime(ts) {
      const t = Number(ts || 0) * 1000;
      if (!t) return "";
      const d = new Date(t);
      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    formatOpenDetail(row) {
      const deviceId = (row && row.deviceId) ? String(row.deviceId) : "";
      const deviceName = (row && row.deviceName) ? String(row.deviceName) : "";
      const who = (row && row.operatorName) ? String(row.operatorName) : "";
      const from = (row && row.openTypeLabel) ? String(row.openTypeLabel) : "";

      const dev =
        deviceId && deviceName ? `设备${deviceId}（${deviceName}）` :
        deviceId ? `设备${deviceId}` :
        deviceName ? `设备（${deviceName}）` : "设备未知";

      const whoText = who ? `，操作人：${who}` : "";
      return `${from}：${dev}${whoText}`;
    },
    onFilterChange() {
      this.page = 1;
      this.refresh();
    },
    async refresh() {
      this.loading = true;
      try {
        const res = await getOpenLogs({
          page: this.page,
          pageSize: this.pageSize,
          openType: this.openType,
          keyword: this.keyword
        });
        const data = (res && res.data) || {};
        this.list = data.list || [];
        this.total = Number(data.total || 0);
      } catch (e) {
        this.$message.error("加载开门日志失败");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.title {
  display: flex;
  align-items: center;
  font-weight: 600;
}
.filters {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>

